export const TACTIC_HELP_URL = 'https://gettactic.zendesk.com/hc/en-us';
